import { isEmpty, isNil } from "lodash-es"

export function capitalize(target: string): string {
  return target.charAt(0).toUpperCase() + target.slice(1).toLowerCase()
}

export function titleize(target: string): string {
  return target.split(" ").map(capitalize).join(" ")
}

export function isNilOrEmpty(value: any) {
  return isNil(value) || isEmpty(value)
}

export function isInListCaseInsensitive(list: string[], value?: string) {
  if (!value) {
    return true
  } // When using in a schema validation, mandatory fields would be .required()

  const lowerValue = value.toLowerCase()
  return list.some((str) => str.toLowerCase() === lowerValue)
}
